import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";

export const calculateRealestateRentBase = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const rent = userProduct?.rent || 0;

  return convertCurrency(rent, baseCurrency, currentCurrency);
};

export const calculateRealestateRentType = (userProduct: RealestateAsset) => {
  const paymentPeriod = userProduct?.incomeFrequency;
  if (!paymentPeriod || !paymentPeriod?.value) return 0;

  const paymentOptions: Record<string, number> = {
    monthly: 12,
    biMonthly: 6,
    quarterly: 4,
    semiannual: 2,
    yearly: 1,
  };

  return paymentOptions[paymentPeriod?.value];
};


export const calculateRentYearly = (userProduct: RealestateAsset) => {
  const rent = userProduct?.rent || 0;
  const incomeFrequency = userProduct?.incomeFrequency?.value || "";

  const paymentOptions: Record<string, number> = {
    monthly: 12,
    biMonthly: 6,
    quarterly: 4,
    semiannual: 2,
    yearly: 1,
  };

  const multiplication = paymentOptions[incomeFrequency] || 0;
  return rent * multiplication;
}